import { SAVE_USER, SAVE_USER_SUCCESS, SAVE_USER_ERROR } from "../actions/user";
import { updateDts } from "./updateDailyText";
import updateReminders from "./updateReminders";

export default payload => (dispatch, getState) => {
  const {
    user: {
      data: { _id: user_id, timezone = 0 }
    },
    dailytexts: {
      data: { days = [], hours = [] }
    }
  } = getState();

  if (!user_id) return Promise.resolve();
  dispatch({ type: SAVE_USER, payload });

  const reminder = (timezone - payload.timezone) * 1000 * 60 * 60;

  return fetch(`${process.env.REACT_APP_USERDATA_URI}/update/user/${user_id}`, {
    method: "POST",
    body: JSON.stringify(payload)
  })
    .then(res => res.json())
    .then(payload => {
      return Promise.all([
        dispatch(updateDts({ hours, days })),
        dispatch(updateReminders({ $inc: { reminder } }))
      ]).then(() => dispatch({ type: SAVE_USER_SUCCESS, payload }));
    })
    .catch(({ message: payload }) =>
      dispatch({ type: SAVE_USER_ERROR, payload })
    );
};



// WEBPACK FOOTER //
// ./src/store/epics/updateTimezone.js